import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircleIcon, EnvelopeIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

function InviteCancelled() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  const handleGoToSubscription = () => {
    navigate('/register-company');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="rounded-full bg-red-100 p-4">
              <XCircleIcon className="h-16 w-16 text-red-600" />
            </div>
          </div>

          {/* Title */}
          <div className="text-center space-y-2">
            <h1 className="text-2xl font-bold text-gray-900">
              Davet İptal Edildi
            </h1>
            <p className="text-gray-600">
              Maalesef bu davet linki iptal edilmiştir
            </p>
          </div>

          {/* Email Display */}
          {email && (
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <EnvelopeIcon className="h-5 w-5" />
                <span className="font-medium">{email}</span>
              </div>
            </div>
          )}

          {/* Information Box */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-blue-900 text-sm">
              Ne Yapabilirsiniz?
            </h3>
            <ul className="space-y-2 text-sm text-blue-800">
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>
                  Yöneticinizle iletişime geçerek yeniden davet edilebilirsiniz
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>
                  Yeniden davet edildiğinizde size e-posta gönderilecektir
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-0.5">•</span>
                <span>
                  İsterseniz kendiniz de abonelik başlatabilirsiniz
                </span>
              </li>
            </ul>
          </div>

          {/* Action Button */}
          <button
            onClick={handleGoToSubscription}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
          >
            <span>Abonelik Başlat</span>
            <ArrowRightIcon className="h-5 w-5" />
          </button>

          {/* Footer */}
          <div className="text-center pt-4">
            <p className="text-xs text-gray-500">
              Yardıma mı ihtiyacınız var?{' '}
              <a 
                href="mailto:destek@advancecash.io" 
                className="text-blue-600 hover:text-blue-700 font-medium"
              >
                Bizimle iletişime geçin
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InviteCancelled;
